<template>
    <div class="registration-tips">
        <p class="tips-title">欢迎使用投米应用！我们将通过<span class="tipsColor colorGold" @click="goAssessment($event, 1)" data-url="privacyPolicy">《注册服务协议》</span>、<span class="tipsColor colorGold" @click="goAssessment($event, 0)" data-url="privacyPolicy">《隐私政策》</span>和<span class="tipsColor colorGold" data-url="privacyLimits" @click="goAssessment($event, '')">《权限说明》</span>帮助您了解我们收集、使用、储存和共享个人信息的情况，了解您的相关权利。</p>
        <p>
            请仔细阅读，如您同意，请点击下方“同意”按钮以接受我们的服务。
        </p>
    </div>
</template>
<script>
import { bridgeRedirect } from "../../../utils/bridge";
export default {
    data() {
        return {};
    },
    created() {},

    methods: {
        goAssessment: function(e, type) {
            let url = e.target.getAttribute("data-url");
            bridgeRedirect(`${location.origin}${location.pathname}#/${url}?source=${type}`);
        }
    }
};
</script>

<style lang="less">
.registration-tips {
    width: 100%;
    box-sizing: border-box;
    padding: 20px 16px;
    background: #fff;

    p {
        text-align: left;
        display: block;
        width: 100%;
        font-size: 15px;
        color: #333333;
        margin-bottom: 18px;
        line-height: 20px;
    }
    .tipsColor {
    }
}
</style>
